<script>
import AdminLayout from '@layouts/admin-main'
import BrokerageList from '@components/admin/brokerage-list'

export default {
  page: {
    title: 'Admin::BrokerageList',
    meta: [{ name: 'description', content: 'Admin::BrokerageList' }],
  },
  components: { AdminLayout, BrokerageList },
}
</script>

<template>
  <AdminLayout>
    <BrokerageList></BrokerageList>
  </AdminLayout>
</template>

<style lang="scss" module>
@import '@design';
</style>
